import Button from '../Button/Button.vivus';
import color from 'color';
import normalizeColors from '../libs/normalizeColors';
import Slider from '../SliderWithControls/Slider/Slider.vivus';
import SliderStep from '../SliderWithControls/Slider/SliderStep.vivus';
import { fromJS } from 'immutable';
export default fromJS({
  name: 'vivus',
  globals: {
    colors: normalizeColors({
      primaryLighter: '#E4F1C1',
      primaryLight: '#BBD968',
      primary: '#A6CE39',
      primaryDarker: '#91B332',
      background: '#eceef2',
      backgroundDarker: '#E4E6EA',
      secondary: '#006D38',
      secondaryDarker: color('#006D38').darken(0.2).hex(),
      additional: '#6C6F70',
      error: '#D24136',
      white: '#ffffff',
      whiteDark: '#CBD3DA',
      black: '#000000',
      light: '#ffffff',
      dark: '#2B2B2B',
      gray: '#ABABAB',
      grayBlue: '#A1B4BE',
      blue: '#3695d1',
      grayDark: '#4d4d4d',
      grayDarker: '#46484B',
      grayLight: '#B3B3B3',
      monotone1: '#f2f2f2',
      monotone2: '#d5d5d5',
      monotone3: '#959595',
      monotone4: '#555555',
      monotone5: '#363636',
      inputColor: '#474747',
      inputBorder: '#d3d3d3',
      yellowLight: '#FFD900',
      yellow: '#E06700'
    }),
    borders: {
      calculator: '8px'
    }
  },
  Button: Button,
  Slider: Slider,
  SliderStep: SliderStep
});